export enum BookingMarketsEnabledAttribute {
  Master = 834,
}
